<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_(screen.menuTitle)" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>

		<template v-slot:content>
			<car-sale-content
				ref="content"
				:scrId="scrId"
				:pStartDt="pStartDt"
				:pEndDt="pEndDt"
				:pState1="pState1"
				:pState2="pState2"
				:pState3="pState3"
				:pState4="pState4"
				:pState5="pState5"
				:pState6="pState6"
				:pState10="pState10"
				
			/>
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@mqy/qlty/CarSale/store/helpers';
import CarSaleContent from './Content/CarSaleContent.vue';

export default {
	props: {
		scrId: { type: String, default: '' },
		pStartDt: { type: String, default: '' }, //시작일자
		pEndDt: { type: String, default: '' }, //종료일자
		pState1: { type: String, default: '' }, //차량구분
		pState2: { type: String, default: '' }, //승상구분
		pState3: { type: String, default: '' }, //연료전지사양
		pState4: { type: String, default: '' }, //판매지역
		pState5: { type: String, default: '' },//날짜구분
		pState6: { type: String, default: '' },//날짜구분
		pState10: { type: String, default: '' }//날짜구분
	},
	created() {
		this.setStateInit_();
		this.screen = this.screenArray.get(this.scrId);
	},
	components: {
		CarSaleContent
	},
	data() {
		return {
			title: '가격 현황',
			favorite: true,
			screen: {}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
